import { Link } from "react-router-dom";

const navLinks = [
  { label: "HOME", path: "/" },
  { label: "事業内容", path: "/business" },
  { label: "会社概要", path: "/company" },
  { label: "採用情報", path: "/recruit" },
  { label: "お問い合わせ", path: "/contact" },
];

const snsLinks = [
  { label: "Instagram", icon: "ri-instagram-line", href: "https://www.instagram.com/granstark_security?igsh=MWxkZjM1bzZnY2JlbA==" },
  { label: "X", icon: "ri-twitter-x-line", href: "https://x.com/granstark" },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* NAP Microdata */}
          <div itemScope itemType="https://schema.org/LocalBusiness">
            <img
              src="/images/logo.png"
              alt="株式会社GRANSTARKのロゴ"
              className="h-12 w-auto object-contain mb-4"
              loading="lazy"
            />
            <h3 className="text-lg font-bold mb-3" itemProp="name">株式会社GRANSTARK</h3>
            <p className="text-sm text-gray-300 leading-relaxed" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <span itemProp="postalCode">〒556-0003</span><br />
              <span itemProp="addressRegion">大阪府</span><span itemProp="addressLocality">大阪市浪速区</span><br />
              <span itemProp="streetAddress">難波中3-9-3 南朝日ビル804号</span>
            </p>
            <p className="text-sm text-gray-300 mt-3 leading-relaxed">
              TEL：<a href="tel:0667869252" itemProp="telephone" className="text-gold hover:underline">06-6786-9252</a><br />
              FAX：06-6786-9253
            </p>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-wider mb-5 font-bold">NAVIGATION</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white hover:text-gold transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-wider mb-5 font-bold">FOLLOW US</h4>
            <ul className="space-y-3">
              {snsLinks.map((sns) => (
                <li key={sns.label}>
                  <a
                    href={sns.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-white hover:text-gold transition-colors duration-200 flex items-center gap-2"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={sns.icon}></i>
                    </span>
                    {sns.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#E47911] text-sm tracking-wider mb-5 font-bold">CONTACT</h4>
            <p className="text-2xl md:text-3xl font-bold text-white mb-4">
              <a href="tel:08045635272" className="hover:underline">080-4563-5272</a>
            </p>
            <Link
              to="/contact"
              className="inline-block border border-[#E47911] text-[#E47911] font-bold text-sm px-6 py-3 rounded-lg transition-all duration-300 hover:bg-[#E47911] hover:text-white"
            >
              お問い合わせ
            </Link>
          </div>
        </div>

        <div className="mt-12">
          <div className="w-full h-[300px] rounded-lg overflow-hidden border border-white/10">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.263879760329!2d135.498058!3d34.667217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e76c8a82890f%3A0xa02a3e17b96d1668!2z5pel5pys44CB44CSNTU2LTAwMDMg5aSn6Ziq5bqc5aSn6Ziq55yM5aSn6Ziq5biC5rWm6YCf5YWs5ZyS77yT5LiB55uu77yZ4oiS77ySIOWkoumHjueJqeeZv-W3nOeJqQ!5e0!3m2!1sja!2sus!4v1715000000000!5m2!1sja!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="株式会社GRANSTARK 所在地"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="w-full px-4 md:px-8 py-6 text-center">
          <p className="text-xs text-gray-400">
            Copyright &copy; 2024 GS Co.,Ltd All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
